export default function TrustStrip({ t }) {
  return (
    <div className="stats">
      <div className="container">
        <div className="reveal stats-card">
          <div className="stats-label">
            <span className="dot" /> {t.label}
          </div>
          <div className="stats-list">
            {t.stats.map((s) => (
              <div key={s.label}>
                <div className="stat-num">{s.big}</div>
                <div className="stat-lbl">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
